<template>
  <div class="SortMenu">
    <DropdownMenu :dropped.sync="isDropped" class="mr-0">
      <span slot="label">
        <span class="d-none d-md-inline hidden-xs-down mr-2">
          {{ $t("assets.sort") }}
        </span>
        <b>{{ $t(`assets.sort_name.${sortBy}`) }}</b>
      </span>

      <div slot="dropdown" class="SortMenu__List">
        <button
          class="SortMenu__List-Item"
          v-for="column in sortByColumns"
          v-bind:key="column.name"
          @click="setSortByAndClose(column.name)"
        >
          {{ $t(`assets.sort_name.${column.name}`) }}
          <AssetTableSortIcon
            :column="column.name"
            class="fa-fw SortMenu__List-Icon"
          />
        </button>
      </div>
    </DropdownMenu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DropdownMenu from "./DropdownMenu.vue";
import AssetTableSortIcon from "./AssetTableSortIcon.vue";

export default {
  name: "SortMenu",
  components: {
    DropdownMenu,
    AssetTableSortIcon,
  },
  data() {
    return {
      isDropped: false,
    };
  },
  computed: {
    ...mapGetters({
      sortBy: "settings/sortBy",
      sortByColumns: "settings/sortByColumns",
    }),
  },
  methods: {
    setSortBy(column) {
      if (this.sortBy === column) {
        this.toggleSetting("sortByDir");
      } else {
        this.setSetting({ setting: "sortBy", value: column });
        this.setSetting({ setting: "sortByDir", value: true });
      }
    },
    setSortByAndClose(column) {
      if (this.sortBy === column) {
        this.toggleSetting("sortByDir");
      } else {
        this.setSetting({ setting: "sortBy", value: column });
        this.setSetting({ setting: "sortByDir", value: true });
      }
      this.isDropped = false;
    },
    ...mapActions({
      setSetting: "settings/setSetting",
      toggleSetting: "settings/toggleSetting",
    }),
  },
};
</script>

<style lang="scss">
@import "~@/scss/variables";
@import "~@/scss/mixins";

.SortMenu {
  display: inline-block;
}

.SortMenu__List {
  width: 160px;
}

.SortMenu__List-Item {
  cursor: pointer;
  white-space: nowrap;
  padding: 5px 20px;
  display: block;
  color: #222;
  text-decoration: none;
  border: 0;
  background: none;
  width: 100%;
  text-align: left;
  font-size: 16px;
  transition: background 0.1s;

  &:hover {
    color: $color-secondary;
    background: #f4f4f4;
  }

  .SortMenu__List-Icon {
    float: right;
    margin: 3px 0 0;
  }
}
</style>
